"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnowflakeSqlGenerator = void 0;
const base_1 = require("./base");
class SnowflakeSqlGenerator extends base_1.BaseSqlGenerator {
    quoteIdentifier(name) {
        return `"${name.replace(/"/g, '""')}"`;
    }
}
exports.SnowflakeSqlGenerator = SnowflakeSqlGenerator;
//# sourceMappingURL=snowflake.js.map